<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container text-center"
          style="background: white"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <h3 class="zone_header_text mt-4">
            {{ $t("text.manageOrders.title") }}: {{ orderCount }}
          </h3>
          <div class="dealer__icon__wrapper mt-3">
            <div class="dealer__icon__div text-center">
              <div>
                <img src="@/assets/img/truck (1).png" width="80%" />
              </div>
            </div>
          </div>
        </div>

        <div class="zone_header_container">
          <div
            class="card_container"
            style="
              flex: 0 0 25%;
              min-height: 180px;
              border-radius: 10px 0 0 10px;
            "
          >
            <div class="row align-items-center fuel_consumption_buttons_row">
              <div class="col-md-12 fuel_consumption_btn_div mt-3">
                <div
                  class="fuel_consumption_button installed__tanks_dropdown__row ml-3 showAllContainer"
                  style="
                    width: 87%;
                    padding: 5px;
                    cursor: pointer;
                    border-radius: 5px;
                  "
                >
                  <div
                    class="row installed__pumps_dropdown align-items-center"
                    @click="toggleOrderstatusFilterDropdown"
                    v-on:mouseleave="
                      showOrderStatusFilter === true
                        ? (showOrderStatusFilter = false)
                        : ''
                    "
                  >
                    <div class="col-md-3 dropdown_img">
                      <img src="@/assets/img/y.png" />
                    </div>
                    <div class="col-md-7">
                      <input
                        type="text"
                        class="installed__pumps_dropdown_input"
                        readonly
                        v-model="orderStatus"
                      />
                    </div>
                    <div class="col-md-2 angle-right">
                      <div>
                        <i
                          style="float: right; font-size: 25px; color: white"
                          class="fa fa-angle-right"
                          :class="[
                            showOrderStatusFilter ? 'downArrow' : 'upArrow',
                          ]"
                        ></i>
                      </div>
                    </div>

                    <div
                      class="return_balance_to_drop_dwon"
                      id="manage_orders"
                      ref="balance_to_drop_down_menu"
                      v-if="showOrderStatusFilter"
                    >
                      <hr class="mt-2" />
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        @click="selectItem('Show All')"
                        style="height: 40px"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.showAll") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Driver Assigned')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.driverAssigned") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Payment Pending')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.paymentPending") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Payment Completed')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.paymentCompleted") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Payment Confirmed')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.paymentConfirmed") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Order Completed')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.orderCompleted") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Order Accepted')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.orderAccepted") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Order Rejected')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.orderRejected") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        style="height: 40px"
                        ref="balance_to_list_row"
                        @click="selectItem('Processing')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.processing") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('In Transit')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.inTransit") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Arrived')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.arrived") }}
                          </h6>
                        </div>
                      </div>

                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Owner Accepted')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.ownerAccepted") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Fill Started')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.fillStarted") }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="row mt-2 active_validity_drop_down_list align-items-center"
                        ref="balance_to_list_row"
                        style="height: 40px"
                        @click="selectItem('Fill Ended')"
                      >
                        <div class="col-md-12 text-center">
                          <h6
                            class="dropdown_header_text mt-2 validity_drop_down_list"
                            ref="validity_drop_down_list"
                          >
                            {{ $t("text.manageOrders.fillEnded") }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center voucher_type mt-4">
                  <b class="primary_text"
                    >{{ $t("text.manageOrders.orderStatusFilter") }}
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div
            class="zone_input_container co_order"
            :style="[
              {
                backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31, 0.92)), url(${backgroundUrl})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                width: '100%',
                paddingBottom: '66px',
                height: '180px',
              },
            ]"
          >
            <div class="row">
              <div class="col-md-6">
                <!-- <div>
                        <button class="create_zone_button" @click="companyOrdersRouter('create_order', null)">
                            ADD ORDER
                            <img
                            src="@/assets/img/git_loader.gif"
                            style="display:none;"
                            width="35px"
                            height="35px"
                            class="ml-3 loader"
                            />
                        </button>
                    </div> -->
              </div>
              <div class="col-md-12">
                <vue-ctk-date-time-picker
                  v-model="dateRange"
                  :max-date="maxDate"
                  :range="true"
                  :autoClose="true"
                  :locale="this.$root.$i18n.locale"
                  :custom-shortcuts="customShortcuts"
                  :color="$store.getters.getDatePickerColor"
                  format="DDMMYYYY"
                  formatted="DD/MM/YYYY"
                  :label="$t('text.calendar.dateRange')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12 mt-3">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="50" field="index" headerText="#"></e-column>
                <e-column
                  width="150"
                  field="contactName"
                  :headerText="$t('text.manageOrders.contactName')"
                ></e-column>
                <e-column
                  width="240"
                  field="contactPhone"
                  :headerText="$t('text.manageOrders.contactPhone')"
                ></e-column>
                <e-column
                  width="150"
                  field="status"
                  :headerText="$t('text.manageOrders.status')"
                ></e-column>
                <e-column
                  width="100"
                  field="quantity"
                  :headerText="$t('text.manageOrders.quantity')"
                ></e-column>
                <e-column
                  width="180"
                  field="city"
                  :headerText="$t('text.manageOrders.city')"
                ></e-column>
                <e-column
                  width="180"
                  field="state"
                  :headerText="$t('text.manageOrders.state')"
                ></e-column>
                <e-column
                  width="450"
                  :template="buttonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </section>
      <TableLoader :showLoader="showLoader"></TableLoader>
      <UpdateOrderstatus :order="order"></UpdateOrderstatus>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import UpdateOrderstatus from "@/components/modals/Order/updateOrderStatus.vue";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Orders:: Epump Portal",
  name: "Manage Drivers",
  components: {
    MasterLayout,
    UpdateOrderstatus,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getOrders();
        this.getAllOrders();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getOrders();
        this.getAllOrders();
      }
    },
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      driver: "",
      orderCount: 0,
      company: null,
      backgroundUrl,
      cardBackgroundUrl,
      zoneId: null,
      zoneName: "",
      order: {},
      showOrderStatusFilter: false,
      showLoader: false,
      orderStatus: this.$t("text.cDashboard.showAllButton"),
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div> 
                  <a :href="'/Company/Order/assign-driver?id=' + data.id + '&companyId=' + $route.query.companyId" class="zone_action_buttons assign_branch" @click="companyOrdersRouter($event, 'assignDriver', data.id)">{{data.assignDriverButton}}</a> 
                   <a :href="'/Company/Order/edit-order?id=' + data.id + '&companyId=' + $route.query.companyId" class="zone_action_buttons edit_category" @click="companyOrdersRouter($event, 'edit_order', data.id)">{{data.editOrderButton}}</a> 
                <button class="mailRecipient_btn view_btn" @click="updateOrderStatus(data)">{{data.updateStatusButton}}</button> 
                </div>

                `,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              companyOrdersRouter($event, route, id) {
                $event.preventDefault();
                this.$eventHub.$emit("companyOrdersRouter", route, id);
              },
              updateOrderStatus(data) {
                this.$eventHub.$emit("setOrderStatus", data);

                this.$modal.show("updateOrderStatus");
              },
              editOrder($event, route, id) {
                $event.preventDefault();
                this.$eventHub.$emit("_editOrder", route, id);
              },
              _deleteOrder(id) {
                this.$eventHub.$emit("archiveOrder", id);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getOrders();
      this.getAllOrders();
    }
    this.$eventHub.$on("companyOrdersRouter", (route, id) => {
      this.companyOrdersRouter(route, id);
    });
    this.$eventHub.$on("setCompanyOrders", (driver) => {
      this.driver = driver;
    });
    this.$eventHub.$on("getOrders", () => {
      this.getOrders();
    });
    this.$eventHub.$on("_editOrder", (route, id) => {
      this.$router.push({ name: route, query: { id: id } });
    });
    this.$eventHub.$on("archiveOrder", (id) => {
      this.deleteOrder(id);
    });

    this.$eventHub.$on("setOrderStatus", (data) => {
      this.order = data;
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("companyOrdersRouter");
    this.$eventHub.$off("setCompanyOrders");
    this.$eventHub.$off("getOrders");
    this.$eventHub.$off("_editOrder");
    this.$eventHub.$off("archiveOrder");
    this.$eventHub.$off("setOrderStatus");
  },

  mounted() {
    let _this = this;
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    companyOrdersRouter(route, id) {
      if (this.$route.name == route) {
        return;
      }
      this.$router.push({
        name: route,
        query: {
          id,
          companyId: this.$route.query.companyId,
        },
      });
    },
    toggleOrderstatusFilterDropdown() {
      this.showOrderStatusFilter = !this.showOrderStatusFilter;
    },
    deleteOrder(id) {
      const remove = confirm(this.$t("text.manageOrders.confirmDelete"));
      if (!remove) {
        return;
      }
      const data = { id: id };
      fetch(`${configObject.apiBaseUrl}/Order/Product`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: configObject.authConfig().headers.Authorization,
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.manageOrders.successfullyDeleted"),
            type: "success",
            duration: 4000,
          });
          this.$eventHub.$emit("getOrders");
        })
        .catch((error) => {
          this.$toast.open({
            message: this.$t("text.manageOrders.unsuccessfulDelete"),
            type: "error",
            duration: 4000,
          });
        });
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    openDriverModal() {
      this.$modal.show("addDriver");
    },
    selectItem(status) {
      if (status === this.$t("text.manageOrders.showAll")) {
        this.orderStatus = status;
        this.getAllOrders();
      } else {
        this.orderStatus = status;
        this.getOrders();
      }
    },
    getAllOrders() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Order/Company/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.contactName > b.contactName
              ? 1
              : b.contactName > a.contactName
              ? -1
              : 0;
          });
          response.data.forEach((order, index) => {
            order.index = index + 1;
            order.assignDriverButton = this.$t(
              "text.manageOrders.assignDriver"
            );
            order.editOrderButton = this.$t("text.manageOrders.editOrder");
            order.updateStatusButton = this.$t(
              "text.manageOrders.updateStatus"
            );
          });
          this.showLoader = false;
          this.orderCount = response.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
          localStorage.setItem("orders", JSON.stringify(response.data));
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getOrders() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Order/Company/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}&status=${
            this.orderStatus
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.contactName > b.contactName
              ? 1
              : b.contactName > a.contactName
              ? -1
              : 0;
          });
          response.data.forEach((order, index) => {
            order.index = index + 1;
            order.assignDriverButton = this.$t(
              "text.manageOrders.assignDriver"
            );
            order.editOrderButton = this.$t("text.manageOrders.editOrder");
            order.updateStatusButton = this.$t(
              "text.manageOrders.updateStatus"
            );
          });
          this.showLoader = false;
          this.orderCount = response.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
          localStorage.setItem("orders", JSON.stringify(response.data));
        })
        .catch((error) => {});
    },
  },
};
</script>

<style>
@media screen and (max-width: 768px) {
  .dropdown_img {
    display: flex;
    justify-content: center;
    width: 101% !important;
  }
  .return_balance_to_drop_dwon {
    top: 94px;
    left: -29px;
    width: 148.56%;
  }
  .angle-right {
    margin-top: -27px !important;
  }
  .addDriver .v--modal-box.v--modal {
    /* top: 88px !important; */
    overflow-y: auto;
    margin: 0 auto;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
  }
  .editDriver .v--modal-box.v--modal {
    /* top: 88px !important; */
    overflow-y: auto;
    margin: 0 auto;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
  }
  .fuel_consumption_btn_div .fuel_consumption_button {
    margin: 0 auto !important;
  }
  .fuelbalance_first_row .card_container,
  .zone_input_container {
    margin-top: 15px !important;
    border-radius: 10px !important;
  }
  .zone_input_container {
    padding: 0 !important;
  }
  .fuel_consumption_button.installed__tanks_dropdown__row.ml-3 {
    padding: 11px !important;
    height: 88px !important;
  }
}
</style>
